import {Empty, Loader, ProfileCircleIcon} from 'common/components'
import {useGetOrganisations} from '..'
import { ListPanel } from './ListPanel'
import { List } from './List'
import {
  useStore, 
  setSearchKeyWords as setSearch,
  setPageNumber as setPage,
  setSort,
} from '../store/brokers'

export default function OutletBrokers() {
  const search = useStore((state) => state.searchKeyWords)
  const sort = useStore((state) => state.sort)
  const page = useStore((state) => state.pageNumber)
  const {data: resBody} = useGetOrganisations({
    type: 'broker',
    searchKeyWords: search.trim(),
    pageNumber: page,
  })
  const totalCount = resBody?.meta?.total || resBody?.data?.length || 0
  return (
    <>
      <ListPanel counterType='broker'
        count={totalCount}
        search={search}
        sort={sort}
        setSearch={setSearch}
        setSort={setSort}
      />
      {!resBody?.data ? (
        <Loader />
      ) : !search && resBody.data.length === 0 ? (
        <Empty
          icon={<ProfileCircleIcon width={40} height={40} />}
          title="organisation"
        />
      ) : (
        <List
          items={resBody.data}
          total={totalCount}
          page={page}
          setPage={setPage}
        />
      )}
    </>
  )
}
